import { getSkillIdFromShareSlug, getSkillShareURL, } from '#pplx/frontend/apps/ask/skills/utils/getSkillShareURL.js';
import { getSkillsURL } from '#pplx/frontend/apps/ask/skills/utils/getSkillsURL.js';
import { getMentionUrlParseBase, parseOwnedMentionUrl, } from '#pplx/frontend/apps/ask/skills/utils/mentionLinkUrl.js';
import { validateUuid } from '#pplx/frontend/common/validateUuid.js';
const SKILLS_PATH = '/computer/skills';
const SKILL_ID_QUERY_PARAM = 'skillId';
function appendSkillIdQueryParam(href, skillId) {
    try {
        const url = new URL(href, getMentionUrlParseBase());
        url.searchParams.set(SKILL_ID_QUERY_PARAM, skillId);
        return url.toString();
    }
    catch {
        return href;
    }
}
function parseShareSlug(pathname) {
    const normalizedPathname = pathname.replace(/\/+$/, '');
    if (normalizedPathname === SKILLS_PATH) {
        return {
            isMalformed: false,
            skillIdFromShareSlug: null,
        };
    }
    if (!normalizedPathname.startsWith(`${SKILLS_PATH}/`)) {
        return null;
    }
    const encodedSlug = normalizedPathname.slice(`${SKILLS_PATH}/`.length).split('/')[0] ?? '';
    if (!encodedSlug) {
        return null;
    }
    try {
        return {
            isMalformed: false,
            skillIdFromShareSlug: getSkillIdFromShareSlug(decodeURIComponent(encodedSlug)),
        };
    }
    catch {
        return {
            isMalformed: true,
            skillIdFromShareSlug: null,
        };
    }
}
function isSkillsPath(pathname) {
    const normalizedPathname = pathname.replace(/\/+$/, '');
    return normalizedPathname === SKILLS_PATH || normalizedPathname.startsWith(`${SKILLS_PATH}/`);
}
export function getSkillMentionTarget(rawUrl) {
    const url = parseOwnedMentionUrl(rawUrl);
    if (!url)
        return null;
    if (!isSkillsPath(url.pathname)) {
        return null;
    }
    const explicitSkillId = url.searchParams.get(SKILL_ID_QUERY_PARAM)?.trim();
    if (explicitSkillId) {
        return { skillIdFromUrl: explicitSkillId };
    }
    const shareSlug = parseShareSlug(url.pathname);
    if (!shareSlug || shareSlug.isMalformed)
        return null;
    return {
        skillIdFromUrl: shareSlug.skillIdFromShareSlug,
    };
}
export function getSkillMentionURL(skill) {
    const href = validateUuid(skill.id) ? getSkillShareURL(skill.id) : getSkillsURL();
    return appendSkillIdQueryParam(href, skill.id);
}
//# sourceMappingURL=getSkillMentionURL.js.map